import { render, staticRenderFns } from "./export.vue?vue&type=template&id=3a494872&"
import script from "./export.ts?vue&type=script&lang=ts&"
export * from "./export.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports